import { ContentType, apiRequest } from '../../../main/services/api'

export interface UploadBubblesResponse {
  imgUrl: string
  shareUrl: string
}

export function uploadMap({ query, data }: { query: string; data: string }) {
  const body = new URLSearchParams(query)

  body.set('file', data.replace('data:image/png;base64,', ''))
  body.set('isScreener', `${window.location.pathname.includes('screener')}`)

  return apiRequest<UploadBubblesResponse>(`/publish_bubbles_submit.ashx`, {
    method: 'POST',
    headers: {
      'Content-Type': ContentType.FormUrlEncoded,
    },
    body,
  })
}
